<template>
  <v-dialog v-model="dialogState" max-width="800" persistent>
    <v-card>

      <v-toolbar
        color="primary"
        flat
        short
      >
        <v-toolbar-title>{{ $t('Key') }}: {{ model.key }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="hideDialog" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form
          autocomplete="off"
        >
          <v-container class="mt-5">
            <v-row>
              <v-col cols="6" sm="6">
                <v-text-field
                  v-model="model.content"
                  :label="$t('Value')"
                  :error-messages="errors.content"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="px-10 pb-10">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="saveItem">{{ $t('Save') }}</v-btn>
        <v-btn color="default" @click="hideDialog">{{ $t('Cancel') }}</v-btn>
      </v-card-actions>

    </v-card>

	<ErrorFlash v-model="errors"/>
  </v-dialog>
</template>

<script>
import ApiService from '@/services/api.service'
import ErrorFlash from '@/components/ErrorFlash'

export default {
  components: {
    ErrorFlash,
  },
  data () {
    return {
      dialogState: false,
      deliveryDateDialog: false,
      
      model: {},
      errors: {},
    }
  },
  watch: {

  },
  computed: {
    isNewItem() {
      return !this.model.id
    },
  },
  created() {
  },
  methods: {
    showDialog(id = null) {
      if (id !== null) {
        this.fetchItem(id)
      }
      this.dialogState = true
    },
    hideDialog() {
      this.dialogState = false

      // resetting the form, unset only the id, the rest will be overwritten by an empty model from the api controller.
      this.model = {}
    },
    setItem(item = {}, reset = false) {
      Object.keys(this.model).forEach(key => {
        if (reset || (key in item)) {
          if (this.model[key].isArray()) {
            this.setItem(this.model[key])
          } else {
            this.model[key] = (key in item) ? item[key] : null
          }
        }
      })
      this.errors = {}      
    },
    getItem() {
      const item = this.model
      return item
    },
    fetchItem(id) {
      this.$store.dispatch('session/showLoader')
      this.errors = {}
      ApiService.view(`/settings/${id}`, {
        params: {
        },
      }).then(item => {
        this.model = item
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    saveItem() {
      this.errors = {}
      this.$store.dispatch('session/showLoader')
      if (this.model.id) {
        ApiService.update(`/settings/${this.model.id}`, {
          ...this.getItem(),
        }).then(item => {
          this.$emit('update', item)
          this.hideDialog()
        }).catch(errors => {
          this.errors = errors
        }).finally(() => {
          this.$store.dispatch('session/hideLoader')
        })
      }
    },
  },
}
</script>
